export default {
    API_ENDPOINT:process.env.REACT_APP_API_ENDPOINT || `https://safe-lowlands-14338.herokuapp.com/api`,
   
    TOKEN_KEY:`sleeptime-client-auth-token`
}